import EdLessonNav from './ed-lesson-nav/ed-lesson-nav.vue';
import EdLessonNavLink from './ed-lesson-nav-link/ed-lesson-nav-link.vue';
import EdPortalInfoSection from './ed-portal-info-section/ed-portal-info-section.vue';
import EdPortalInfoSectionTitle from './ed-portal-info-section-title/ed-portal-info-section-title.vue';
import EdPortalInfoSectionCourseName from './ed-portal-info-section-course-name/ed-portal-info-section-course-name.vue';
import EdEmptyViewer from './ed-empty-viewer/ed-empty-viewer.vue';
import EdSectionTree from './ed-section-tree/ed-section-tree.vue';
import EdSectionObject from './ed-section-object/ed-section-object.vue';
import EdFileViewer from './ed-file-viewer/ed-file-viewer.vue';
import EdSectionCourseMaterials from './ed-section-course-materials/ed-section-course-materials.vue';
import EdPortalSidebar from './ed-portal-sidebar/ed-portal-sidebar.vue';
import EdMeetingDetails from './ed-meeting-details/ed-meeting-details.vue';
import EdMeetingContainer from './ed-meeting-container/ed-meeting-container.component.vue';

export default {
  EdLessonNav,
  EdLessonNavLink,
  EdPortalInfoSection,
  EdPortalInfoSectionTitle,
  EdPortalInfoSectionCourseName,
  EdEmptyViewer,
  EdSectionTree,
  EdSectionObject,
  EdFileViewer,
  EdSectionCourseMaterials,
  EdPortalSidebar,
  EdMeetingDetails,
  EdMeetingContainer
};